import React from 'react';
import './Dashboard.css';
import Sidebar from './Sidebar';
import Overview from './Overview';
import Payment from './Payment';
import Referral from './Referral';
import Instructions from './Instructions';
import Settings from './Settings';
import Documents from './Documents';
import TelegramModal from './TelegramModal';

const Dashboard = ({
  tab,
  pageTitle,
  pageSubtitle,
  navTo,
  navStyle,
  hasSub,
  subsVM,
  anySelected,
  logout,
  selectedCount,
  startRenew,
  startNew,
  backToManage,
  payManage,
  payCheckout,
  payMode,
  payConfirm,
  plan,
  method,
  planStyle,
  payStyle,
  pickM1,
  pickM3,
  pickM6,
  pickM12,
  pickCard,
  pickSbp,
  pickStars,
  pickCrypto,
  planM1Style,
  planM3Style,
  planM6Style,
  planM12Style,
  payCardStyle,
  paySbpStyle,
  payStarsStyle,
  payCryptoStyle,
  checkoutBanner,
  checkoutUnitsLabel,
  totalLabel,
  payButtonLabel,
  infoOpen,
  toggleInfo,
  deviceLimit,
  lteLimit,
  showTgModal,
  tgBound,
  tgNotBound,
  tgIdLabel,
  bindTg,
  skipTg,
  unbindTg,
  copied,
  flash,
  regEmail,
  copyRefSite,
  copyRefBot,
  copiedRefSite,
  copiedRefBot,
  user, 
  onChangePassword,
  is2faEnabled,
  onEnable2fa,
  onConfirmEnable2fa,
  onDisable2fa,
  onPayment,
  referralStats,
  onRequestEmailChange,
  onConfirmEmailChange,
}) => {
  return (
    <div className="dashboard-shell">
      <Sidebar navTo={navTo} navStyle={navStyle} tab={tab} logout={logout} />
      <main className="dashboard-main">
        <div className="head-row">
          <div>
            <h1 className="page-title">{pageTitle}</h1>
            <p className="page-subtitle">{pageSubtitle}</p>
          </div>
        </div>

        {tab === 'overview' && (
          <Overview
            hasSub={hasSub}
            subsVM={subsVM}
            anySelected={anySelected}
            selectedCount={selectedCount}
            startRenew={startRenew}
            startNew={startNew}
            deviceLimit={deviceLimit}
            lteLimit={lteLimit}
            navTo={navTo}
          />
        )}

        {tab === 'payment' && (
          <Payment
            payManage={payManage}
            payCheckout={payCheckout}
            subsVM={subsVM}
            anySelected={anySelected}
            selectedCount={selectedCount}
            startRenew={startRenew}
            startNew={startNew}
            backToManage={backToManage}
            hasSub={hasSub}
            payMode={payMode}
            onPayment={onPayment}
            plan={plan}
            method={method}
            planStyle={planStyle}
            payStyle={payStyle}
            pickM1={pickM1}
            pickM3={pickM3}
            pickM6={pickM6}
            pickM12={pickM12}
            pickCard={pickCard}
            pickSbp={pickSbp}
            pickStars={pickStars}
            pickCrypto={pickCrypto}
            planM1Style={planM1Style}
            planM3Style={planM3Style}
            planM6Style={planM6Style}
            planM12Style={planM12Style}
            payCardStyle={payCardStyle}
            paySbpStyle={paySbpStyle}
            payCryptoStyle={payCryptoStyle}
            payStarsStyle={payStarsStyle}
            checkoutBanner={checkoutBanner}
            checkoutUnitsLabel={checkoutUnitsLabel}
            totalLabel={totalLabel}
            payButtonLabel={payButtonLabel}
            infoOpen={infoOpen}
            toggleInfo={toggleInfo}
            deviceLimit={deviceLimit}
            lteLimit={lteLimit}
          />
        )}

        {tab === 'referral' && (
          <Referral
            copyRefSite={copyRefSite}
            copyRefBot={copyRefBot}
            copiedRefSite={copiedRefSite}
            copiedRefBot={copiedRefBot}
            referralStats={referralStats}
          />
        )}

        {tab === 'instructions' && <Instructions />}
        {tab === 'settings' && (
          <Settings
            regEmail={regEmail}
            tgBound={tgBound}
            tgNotBound={tgNotBound}
            logout={logout}
            tgIdLabel={tgIdLabel}
            bindTg={bindTg}
            unbindTg={unbindTg}
            onChangePassword={onChangePassword}
            is2faEnabled={is2faEnabled}
            onEnable2fa={onEnable2fa}
            onConfirmEnable2fa={onConfirmEnable2fa}
            onDisable2fa={onDisable2fa}
            onRequestEmailChange={onRequestEmailChange}
            onConfirmEmailChange={onConfirmEmailChange}
          />
        )}
        {tab === 'documents' && <Documents />}

        {showTgModal && <TelegramModal bindTg={bindTg} skipTg={skipTg} />}
      </main>
    </div>
  );
};

export default Dashboard;